import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LangService } from '../../service/lang.service';
import { translations } from '../../service/trans';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  isOpen = false;
  @Input() lang!: string;
  @Input() t: any;

  @Output() changeLang = new EventEmitter<string>();

  menuOpen = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private langService: LangService,
  ) {}

  // ngOnInit() {
  //   this.langService.lang$.subscribe((lang) => {
  //     this.lang = lang;
  //     this.t = translations[lang];
  //   });
  // }
  toggleLangMenu(event: Event) {
    event.stopPropagation(); // prevents instant close
    this.menuOpen = !this.menuOpen;
  }

  switchLang(lang: string) {
    this.langService.setLang(lang);

    const urlParts = this.router.url.split('/');
    urlParts[1] = lang; // replace lang

    this.router.navigate(urlParts);
  }
  @HostListener('document:click')
  closeMenu1() {
    this.menuOpen = false;
  }
  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

  closeMenu() {
    this.isOpen = false;
  }
}
